module.exports = __webpack_public_path__ + "img/symbol_16.d5f65663.png";